import { ModalComponent, ServiceInquiryNote } from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ScrollView, Text, useWindowDimensions, View } from 'react-native'
type ServiceInquiryNotePopupProps = {
  infoVisible: boolean
  isLoading: boolean
  setInfoVisible: (value: boolean) => void
  noteDetail: ServiceInquiryNote
  // setNoteDetail: (value: ServiceInquiryNote) => void
}
export const ServiceInquiryNotePopup = (props: ServiceInquiryNotePopupProps) => {
  const { t } = useTranslation()
  const { infoVisible, setInfoVisible, noteDetail, isLoading } = props
  const { height } = useWindowDimensions()
  return (
    <ModalComponent
      title={t('ServiceInquiry:DetailNote')}
      visible={infoVisible}
      onClose={() => setInfoVisible(false)}
      actions={[
        {
          text: t('common:Close'),
          type: 'filled',
          disabled: false,
          loading: isLoading,
          onlyWide: false,
          style: { height: 40 },
          action: () => setInfoVisible(false)
        }
      ]}
    >
      <View style={{ marginHorizontal: 20, marginTop: 20, maxHeight: height - 200 }}>
        <Text style={{ paddingVertical: 10, fontWeight: 'bold' }}>{t('ServiceInquiry:CustomerComment')}</Text>
        <View
          style={{
            minHeight: 80,
            maxHeight: 'calc((100vh - 300px)/2)',
            borderRadius: 5,
            borderWidth: 1,
            borderColor: '#4f4f4f',
            backgroundColor: '#fff',
            padding: 9
          }}
        >
          <ScrollView>
            <Text>{noteDetail.customerComment}</Text>
          </ScrollView>
        </View>
        {/* Response to Customer */}
        <Text style={{ paddingVertical: 10, fontWeight: 'bold' }}>{t('ServiceInquiry:ResponseToCustomer')}</Text>
        <View
          style={{
            minHeight: 80,
            maxHeight: 'calc((100vh - 300px)/2)',
            borderRadius: 5,
            borderWidth: 1,
            borderColor: '#4f4f4f',
            backgroundColor: '#fff',
            padding: 9
          }}
        >
          <ScrollView>
            <Text>{noteDetail.responseToCustomer}</Text>
          </ScrollView>
        </View>

        <Text style={{ paddingVertical: 10, fontWeight: 'bold' }}>{t('ServiceInquiry:ClosedInfo')}</Text>
        <View
          style={{
            minHeight: 80,
            maxHeight: 'calc((100vh - 300px)/2)',
            borderRadius: 5,
            borderWidth: 1,
            borderColor: '#4f4f4f',
            backgroundColor: '#fff',
            padding: 9
          }}
        >
          <ScrollView>
            <Text>{noteDetail.closedInfo}</Text>
          </ScrollView>
        </View>
      </View>
    </ModalComponent>
  )
}